"use strict";

var _defineProperty = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.createUnneededOptionIndexesMap = function (optionPositionsMap, checkedIds) {
  if (!checkedIds.length) return {};
  var optionIndexesMap = {};
  Object.keys(optionPositionsMap).forEach(function (id) {
    if (checkedIds.includes(id)) return;
    var positions = optionPositionsMap[id];
    positions.forEach(function (_ref) {
      var nodeId = _ref.nodeId,
          optionIndex = _ref.optionIndex;

      if (!optionIndexesMap[nodeId]) {
        optionIndexesMap[nodeId] = [optionIndex];
      } else {
        optionIndexesMap[nodeId].push(optionIndex);
      }
    });
  });
  return optionIndexesMap;
};

exports.handleFilterNodeMap = function (nodeMap, unneededOptionIndexesMap) {
  // 削除対象の option を取り除く
  var filterOptions = function filterOptions(nodeId, options) {
    var unneededIndexes = unneededOptionIndexesMap[nodeId];
    if (!unneededIndexes || !unneededIndexes.length) return options;
    return options.filter(function (_, i) {
      return !unneededIndexes.includes(i);
    });
  }; // 削除対象の option を取り除きつつ再帰的に nodeMap を作成


  var filterNodeMap = function filterNodeMap(nodeId) {
    var filteredNodeMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var node = nodeMap[nodeId];
    if (!node) return filteredNodeMap; // 選択肢 が一つもない node も残す

    var filteredOptions = filterOptions(nodeId, node.options);
    filteredNodeMap[nodeId] = _objectSpread({}, node, {
      options: filteredOptions
    });
    return filteredOptions.reduce(function (nodeMap, _ref2) {
      var actionId = _ref2.actionId;
      if (!actionId) return nodeMap;
      return filterNodeMap(actionId, nodeMap);
    }, filteredNodeMap);
  };

  return filterNodeMap;
};

exports.filterTemplate = function (template, templateTopNodeId, optionPositionsMap, checkedIds) {
  var unneededOptionIndexesMap = exports.createUnneededOptionIndexesMap(optionPositionsMap, checkedIds);
  return exports.handleFilterNodeMap(template, unneededOptionIndexesMap)(templateTopNodeId);
};

exports.replaceTopNodeId = function (nodeMap, currentTopNodeId, newTopNodeId) {
  var clone = _objectSpread({}, nodeMap);

  var topNode = clone[currentTopNodeId];
  if (!topNode) return nodeMap;
  delete clone[currentTopNodeId];
  var options = topNode.options;
  options.forEach(function (_ref3) {
    var actionId = _ref3.actionId;
    if (!actionId) return;
    clone[actionId] = _objectSpread({}, nodeMap[actionId], {
      parentId: newTopNodeId
    });
  });
  clone[newTopNodeId] = topNode;
  return clone;
};